// contexts/DeviceTypeContext.tsx
import { createContext, useContext } from "react";

type DeviceType = "desktop" | "mobile";

const DeviceTypeContext = createContext<DeviceType>("desktop");

export const DeviceTypeProvider = DeviceTypeContext.Provider;

export const useDeviceType = (): DeviceType => {
  return useContext(DeviceTypeContext);
};
